import React from "react";
import MarketListPanel from "@features/Market/MainComponents/MarketListPanel";

const MarketSelectCurrency = () => (
  <MarketListPanel variant="sidebar" showTradeMarketLink={false} />
);

export default MarketSelectCurrency;
